import React from 'react';

const PrivacyPolicy = () => {
  return (
    <main className="pt-24 pb-16 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        <div className="prose prose-blue max-w-none text-gray-600">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Introduction</h2>
          <p >Welcome to Teqvis Technologies ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Information We Collect</h2>
          <p>We may collect personal information such as name, email address, phone number, and project details when you fill out our contact forms or request a quote.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. How We Use Your Information</h2>
          <p>We use your information to reply to inquiries, provide services, and improve our website experience. We do not sell your personal data to third parties.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access or disclosure.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at contact@teqvis.in.</p>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
